import * as yup from 'yup';

import { ProductUseType } from 'constants/enums';

export const updatePOSOrderSchema = yup.object().shape({
  useType: yup
    .string()
    .oneOf([ProductUseType.is_adult_use as string, ProductUseType.is_medical_use as string]),
});

export type UpdatePOSOrderFormData = yup.InferType<typeof updatePOSOrderSchema>;
